// Kept dependency-free (no `@kapitalist/utils` etc.) so Storybook's Vite config
// can import it at config-load time without dragging workspace packages through
// native ESM resolution. Nothing but storybook and `./index` should read this.

// NB: This must be kept in sync with `envDefaults` in `vite.config.ts`
// Always remember that anything stored here will be exposed via our public
// JS bundle, hence the `PUBLIC_` prefixes.
export const rawEnv = {
  NODE_ENV: process.env.NODE_ENV,
  PUBLIC_BACKEND_SOURCE: process.env.PUBLIC_BACKEND_SOURCE,
  PUBLIC_DOMAIN_NAME: process.env.PUBLIC_DOMAIN_NAME,
  PUBLIC_NGROK_SUBDOMAIN: process.env.PUBLIC_NGROK_SUBDOMAIN,
  PUBLIC_IP_BACKEND_IP: process.env.PUBLIC_IP_BACKEND_IP,
  PUBLIC_IS_LOCAL_FRONTEND_REMOTE_BACKEND:
    process.env.PUBLIC_IS_LOCAL_FRONTEND_REMOTE_BACKEND,
  PUBLIC_GIT_SHA: process.env.PUBLIC_GIT_SHA,
  PUBLIC_LOCALHOST_IP: process.env.PUBLIC_LOCALHOST_IP,
} as const

export type TRawEnvVarName = keyof typeof rawEnv
